import layoutModule from './layout.module'
export default layoutModule.name
